
    import './styles.scoped.css';
    export default {
  "root": "_root_12utu_3",
  "loading": "_loading_12utu_7",
  "undo-button": "_undo-button_12utu_11"
};
  